import { PMNDemande_Statut } from '@/domain/PMNDemande_Statut'

export class PMNDemande {
    id = 0
    pmnModeleId = 0 as number | null
    reponses: PMNDemande_Reponse[] = []
    produits: PMNDemande_Produit[] = []
    dateCreation = ''
    statut = PMNDemande_Statut.EnCoursRedaction
    codeClient = ''
    signature = false
    filesToken = ''
    userMail = ''
}

export class PMNDemande_Reponse {
    reponse = ''
    pmnModele_InputId = 0
}

export class PMNDemande_Produit {
    produitProposeId = 0
    quantite = 0
}

export class PMNDemande_ProduitExtanded extends PMNDemande_Produit{
    codeArticle = ''
    libelleArticle = ''
    prix = 0
}

export enum TypeMailPMN
{
    MailClassique,
    MailSucces
}
